/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recurring_DismissInputs */

const en_recurring_dismiss = /** @type {(inputs: Recurring_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

const he_recurring_dismiss = /** @type {(inputs: Recurring_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התעלם`)
};

/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Recurring_DismissInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const recurring_dismiss = /** @type {((inputs?: Recurring_DismissInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recurring_DismissInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recurring_dismiss(inputs)
	return he_recurring_dismiss(inputs)
});